import { useContext } from 'react'
import { TrackerContext } from './context'

export const useTracker = () => {
  const tracker = useContext(TrackerContext)
  return tracker
}
